import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { QuestionnaireQuestion, Customer } from '../../shared/models';
import { faSpinner } from '../../icons';
@Component({
    selector: 'app-box-container',
    templateUrl: './box-container.component.html',
    styleUrls: ['./box-container.component.scss'],
    animations: [
        // the fade-in/fade-out animation.
        trigger('fadeInOut', [
            // the "in" style determines the "resting" state of the element when it is visible.
            state('in', style({ opacity: 1 })),
            // fade in when created. this could also be written as transition('void => *')
            transition(':enter', [
                style({ opacity: 0 }),
                animate(600)
            ]),
            // fade out when destroyed. this could also be written as transition('void => *')
            transition(':leave', animate(600, style({ opacity: 0 })))
        ])
    ],
    standalone: false
})
export class BoxContainerComponent implements OnInit {
      faSpinner = faSpinner;
    @Input() questions: QuestionnaireQuestion[];
    @Input() done: boolean;
    @Output() onFinish: EventEmitter<{
      customer: Customer,
      answers: {
        id: number,
        title: string,
        answer: string
      }[]
    }> = new EventEmitter();

    currentQuestion: QuestionnaireQuestion;
    sendingResults: boolean = false;
    sendingAll: boolean = false;
    identification: boolean = false;
    customer = <Customer> {
      name: null,
      email: null,
      phone: null
    };

    answers: {
        id: number,
        title: string,
        answer: string
    }[] = [];

    constructor() {

    }

    ngOnInit() {
        this.loadQuestion(this.questions[0]);
    }
    loadQuestion(question: QuestionnaireQuestion) {
      this.currentQuestion = null;
      setTimeout(() => {
          this.currentQuestion = question;
      }, 100);
    }
    triggerNext(question: QuestionnaireQuestion) {
      this.currentQuestion.answer = question.answer;
      this.answers.push({
          id: question.id,
          title: question.title,
          answer: question.answer
      });
      let next: QuestionnaireQuestion = QuestionnaireQuestion.getNext(this.currentQuestion, this.questions);
      if(next == null) {
        this.identification = true;
        this.currentQuestion = null;
      } else {
        this.loadQuestion(next);
      }
    }

    fetchResults() {
      this.sendingResults = true;
      this.sendingAll = true;
      this.onFinish.emit({customer: this.customer, answers: this.answers});
    }
}
